function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M17 14c1.76 0 3.2 1.3 3.45 2.99.02-.01.03-.01.05-.01a2.5 2.5 0 0 1 0 5L14 22c-1.66 0-3-1.34-3-3 0-1.6 1.26-2.9 2.84-2.98A3.495 3.495 0 0 1 17 14zM12 3c4.732 0 8.689 1.565 8.983 4.021a.726.726 0 0 1 .01.067l.007.117.001 6.531a5.488 5.488 0 0 0-2-1.359V10.12c-1.659.96-4.193 1.512-7.001 1.512-2.807 0-5.341-.551-7-1.512v2.459c0 .396.903.9 2.343 1.28l.426.105c.366.085.761.161 1.18.226l.513.072c.786.1 1.641.16 2.538.16l.02-.001a5.006 5.006 0 0 0-2.237 1.898c-1.908-.179-3.578-.594-4.783-1.21v2.049c0 .302.524.666 1.41.99l.35.12c.182.059.377.116.583.17l.426.105c.366.085.761.161 1.18.226l.056.009a5.057 5.057 0 0 0 .349 2.076l-.023-.003-.555-.072c-3.265-.474-5.625-1.69-5.769-3.449L3 17.205v-10c0-.063.006-.124.017-.184C3.31 4.565 7.267 3 12 3zm5 13c-.97 0-1.75.78-1.75 1.75V18H14c-.55 0-1 .45-1 1s.45 1 1 1h6.51l.088-.008a.521.521 0 0 0 .412-.492c0-.28-.22-.5-.5-.5h-1.76v-1.25c0-.97-.78-1.75-1.75-1.75zM12 5C8.083 5 5 6.278 5 7.316c0 1.038 3.083 2.316 7 2.316s7-1.278 7-2.316C19 6.278 15.917 5 12 5z",
  fill: "currentColor",
  fillRule: "nonzero"
});

var SvgIconDataCloud = function SvgIconDataCloud(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/icon-data-cloud.e7247833.svg";
export { SvgIconDataCloud as ReactComponent };